export const events = {
  installAnyAppSuccess: 'Install any App Success',
  uninstallAnyAppSuccess: 'Uninstall any App Success',
}
